import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { useTranslate } from "src/locales";
//IDOGAN;447725;24022025

interface ByzMuiSearchButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  link?: string;
  loading?: boolean;
}

const StyledButton = styled(Button)(({ theme }) => ({
  width: "50px",
  height: "50px",
  borderRadius: "100px",
  padding: 0,
  minWidth: "unset",
  backgroundColor: "#2196F3",
  transition: "background-color 0.2s ease-in-out",
  boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    backgroundColor: "#2979C3",
  },
  "&.Mui-disabled": {
    backgroundColor: "#bdbdbd",
  },
}));

const ByzMuiSearchButton: React.FC<ByzMuiSearchButtonProps> = ({ onClick, link, loading, disabled, ...rest }) => {
  const [hover, setHover] = useState(false);
  const { t } = useTranslate();

  const buttonContent = loading ? (
    <CircularProgress size={20} sx={{ color: "white" }} />
  ) : (
    <img
      src="/assets/icons/search/search.svg"
      alt={t("search")}
      style={{
        width: "20px",
        height: "20px",
        transition: "opacity 0.2s ease-in-out",
        opacity: hover ? 1 : 0.9,
      }}
    />
  );

  return link ? (
    <Link to={link} style={{ textDecoration: "none" }}>
      <StyledButton
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        disabled={disabled || loading}
        {...rest}
      >
        {buttonContent}
      </StyledButton>
    </Link>
  ) : (
    <StyledButton
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      disabled={disabled || loading}
      {...rest}
    >
      {buttonContent}
    </StyledButton>
  );
};

export default ByzMuiSearchButton;
